<template>
  <div :class="['result']">
    <div class="content">
      <p :class="{ 'font-weight-bold': lang === 'ru' }" v-text="title ? title : translations[lang].title" class="title" />
      <p v-text="translations[lang].subtitle" class="subtitle" />
      <div class="result__wrapper">
        <div v-for="(item, index) in translations[lang].items" :key="index" class="result__item">
          <div class="result__icon">
            <img :alt="item.title" :src="require(`@/assets/img/${item.logo}`)" />
          </div>
          <p v-text="item.title" class="result__title" />
        </div>
      </div>
      <div v-if="isCian" class="result__button">
        <button @click="onCianHandler" class="custom-button" v-text="button" />
      </div>
      <div v-if="button && !isCian" class="result__button">
        <button class="custom-button" @click="() => $router.push('/pricing')">
          <!-- <input
            @change="(e) => open('getbundle', e.target.files)"
            multiple
            accept="image/*,application/pdf"
            type="file"
            name="uploaded-plan"
            id="upload-plan-input"
            title=""/> -->
          {{ button }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Result',
  props: {
    lang: {
      type: String,
      default: 'en',
    },
    open: {
      default: () => null,
      type: Function,
    },
    title: {
      default: null,
      type: String,
    },
    subtitle: {
      default: null,
      type: String,
    },
    button: {
      default: null,
      type: String,
    },
    btnHandler: {
      default: () => null,
      type: Function,
    },
    isCian: {
      default: false,
      type: Boolean,
    },
  },
  data: () => ({
    translations: {
      en: {
        items: [
          {
            title: '2D basic floor plan',
            logo: 'result/1.webp',
          },
          {
            title: '3D Full Color',
            logo: 'result/2.webp',
          },
          {
            title: '360° Virtual Tour',
            logo: 'result/3.webp',
          },
          {
            title: 'Renders',
            logo: 'result/4.webp',
          },
        ],
        subtitle: 'Examples of visualization produced by AI Getfloorplan',
        title: 'What materials AI does create?',
      },
      ru: {
        items: [
          {
            title: '2D',
            logo: 'result/1.webp',
          },
          {
            title: '3D',
            logo: 'result/2.webp',
          },
          {
            title: 'Тур 360°',
            logo: 'result/3.webp',
          },
          {
            title: 'Рендеры',
            logo: 'result/4.webp',
          },
        ],
        subtitle: 'Примеры маркетинговых материалов сгенерированных AI Hart Estate',
        title: 'Что создает ИИ?',
      },
    },
  }),

  methods: {
    onCianHandler() {
      this.btnHandler();
    },
  },
};
</script>
